import axios from 'axios';

import apiConstants from './constants/api-constants';
import Helpers from '../common/helpers';

class DashboardApi {
  static getChartData() {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.dashboard_routes.get_chart_data);

    return axios(request);
  }

  static getSummary() {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.dashboard_routes.get_summary);

    return axios(request);
  }
}

export default DashboardApi;



// WEBPACK FOOTER //
// ./src/api/dashboard-api.js